import RichTextParser from './RichTextParser';

export default RichTextParser;
export * from './RichTextParser';
